import React, { useState } from 'react'; // Added useState
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiGrid, FiSearch } from 'react-icons/fi'; // Added FiSearch
import './AllCategories.css'; 

const AllCategories = ({ categories = [] }) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState(""); // State for filtering

  // Filter categories based on search input
  const filteredCategories = categories.filter(cat => 
    cat.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="all-categories-container">
      {/* High-End Header */}
      <header className="cat-page-header">
        <div className="header-left">
          <button className="back-btn" onClick={() => navigate('/agro')}>
            <FiArrowLeft />
          </button>
          <div>
            <h1>Explore Categories</h1>
            <p>{categories.length} Specialized Departments</p>
          </div>
        </div>
        
        {/* Innovative Search Bar */}
        <div className="cat-search-wrapper">
          <FiSearch className="search-icon" />
          <input 
            type="text" 
            placeholder="Search departments..." 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="cat-search-input"
          />
        </div>

        <FiGrid className="header-icon desktop-only" />
      </header>

      {/* Main Grid */}
      <div className="categories-ultra-grid">
        {filteredCategories.length > 0 ? (
          filteredCategories.map((cat, i) => (
<div 
  key={i} 
  className="premium-cat-card" 
  onClick={() => {
    // If user clicks "All", navigate to /agro (or your main products page)
    if (cat.name.toLowerCase() === 'all') {
      navigate('/agro');
    } else {
      // Otherwise, navigate to the specific category page
      navigate(`/category/${cat.name.toLowerCase()}`);
    }
  }}
  style={{ '--accent-color': cat.color || '#2d6a4f' }}
>
              <div className="card-glass-layer"></div>
              <div className="icon-wrapper">
                <span className="main-icon">{cat.icon}</span>
              </div>
              <div className="cat-info">
                <h3>{cat.name}</h3>
                <span className="view-text">View Products →</span>
              </div>
            </div>
          ))
        ) : (
          <div className="no-results">
            <p>No categories match "{searchTerm}"</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AllCategories;